import { Link } from "react-router-dom";
import { hotArticles } from "@/mocks/articles";

export default function ArticleSidebar() {
  return (
    <div className="flex flex-col gap-6">
      <div className="rounded-lg bg-secondary-950 p-6">
        <h2 className="text-base font-semibold text-background-50 flex items-center gap-2">
          <i className="ri-fire-line w-5 h-5 flex items-center justify-center text-accent-400"></i>
          热瓜榜 TOP 5
        </h2>
        <ol className="mt-4 space-y-3">
          {hotArticles.slice(0, 5).map((article, index) => (
            <li key={article.slug}>
              <Link to={`/article/${article.slug}`} className="group flex gap-3">
                <span className="text-sm font-bold text-accent-400 tabular-nums">{index + 1}</span>
                <span className="text-sm text-secondary-100 group-hover:text-accent-300 transition-colors leading-snug">
                  {article.title}
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg bg-primary-50 border border-primary-200 p-6">
        <h2 className="text-base font-semibold text-foreground-950">想边吃边聊？</h2>
        <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
          进聊天室和大家一起蹲后续，最新进展第一时间同步，反转来了也不用自己刷。
        </p>
        <Link
          to="/chat"
          className="mt-4 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-chat-smile-2-line w-4 h-4 flex items-center justify-center"></i>
          进聊天室
        </Link>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-6">
        <h2 className="text-base font-semibold text-foreground-950 flex items-center gap-2">
          <i className="ri-compass-3-line w-5 h-5 flex items-center justify-center text-secondary-600"></i>
          围观小贴士
        </h2>
        <ul className="mt-4 space-y-2.5 text-sm text-foreground-600 leading-relaxed">
          <li className="flex gap-2">
            <i className="ri-check-line w-4 h-4 flex items-center justify-center text-secondary-500 mt-0.5 shrink-0"></i>
            先固定时间线，再去看观点
          </li>
          <li className="flex gap-2">
            <i className="ri-check-line w-4 h-4 flex items-center justify-center text-secondary-500 mt-0.5 shrink-0"></i>
            给信息源分级，区分原文与转述
          </li>
          <li className="flex gap-2">
            <i className="ri-check-line w-4 h-4 flex items-center justify-center text-secondary-500 mt-0.5 shrink-0"></i>
            对反转保持平常心，更新即可
          </li>
        </ul>
      </div>
    </div>
  );
}